import moment from 'moment'
import { get } from 'resources/Ticket/types'

function withTime(base, date) {
  if (moment(date).get('hours') || moment(date).get('minutes')) {
    return `${base} [at] hh:mm a`
  }

  return base
}

export function humanize(date) {
  return moment(date).calendar(moment(), {
    sameDay: () => {
      return `[${moment(date).fromNow()}]`
    },
    nextDay: () => {
      if (
        moment(date).isBetween(
          moment().subtract(12, 'hours'),
          moment().add(12, 'hours')
        )
      ) {
        return `[${moment(date).fromNow()}]`
      }

      return withTime('[Tomorrow]', date)
    },
    nextWeek: () => {
      const diff = moment(date)
        .startOf('day')
        .diff(moment().startOf('day'), 'days')

      return `[in ${diff} days]`
    },
    lastDay: () => {
      if (
        moment(date).isBetween(
          moment().subtract(12, 'hours'),
          moment().add(12, 'hours')
        )
      ) {
        return `[${moment(date).fromNow()}]`
      }

      return withTime('[Yesterday]', date)
    },
    lastWeek: () => {
      const diff = moment(date)
        .startOf('day')
        .diff(moment().startOf('day'), 'days')

      return `[${Math.abs(diff)} days ago]`
    },
    sameElse: () => {
      return `DD MMM YYYY`
    },
  })
}

const normalize = ticket => {
  const {
    offers = [],
    consumers = [],
    tickets = [],
    bills = [],
    merchants = [],
    leads = [],
    reverseRelatedTickets = [],
  } = ticket

  const entities = [
    ...consumers.map(data => ({ type: 'consumers', id: data.id, data })),
    ...offers.map(data => ({ type: 'offers', id: data.id, data })),
    ...bills.map(data => ({ type: 'bills', id: data.id, data })),
    ...merchants.map(data => ({ type: 'merchants', id: data.id, data })),
    ...leads.map(data => ({ type: 'leads', id: data.id, data })),
    ...tickets.map(data => ({ type: 'tickets', id: data.id, data })),
    ...reverseRelatedTickets.map(data => ({
      type: 'tickets',
      id: data.id,
      data,
    })),
  ]

  return {
    ...ticket,
    entities,
    typeLabel: get(ticket.type),
    isOverdue: !ticket.isResolved && moment(ticket.overdueAt).isBefore(),
    overdueAtHumanized: ticket.overdueAt ? humanize(ticket.overdueAt) : null,
    // countryCodes: ['gb', 'nl', 'es'],
  }
}

export default normalize

export function normalizeEntityLinks(data) {
  const { entities, reverseRelatedTickets } = data

  const mappedReverseRelatedTickets = []

  const filteredEntities = entities.filter(e => {
    if (e.type === 'tickets') {
      const t = reverseRelatedTickets.find(rrt => rrt.id === e.id)

      if (t) {
        mappedReverseRelatedTickets.push(t.id)
        return false
      }
    }

    return true
  })

  return {
    ...data,
    entities: filteredEntities,
    reverseRelatedTickets: mappedReverseRelatedTickets,
  }
}
